// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * Placeholder home page rendered at the root route.
 * Currently displays an empty flex layout for future content.
 */

import React from "react";

/**
 * Home page component — serves as the landing view for the application.
 */
const Page: React.FC = () => {
  return (
    <div className="layout" style={{ display: "flex" }}>
    </div>
  );
};

export default Page;
